import { Link } from "react-router-dom";

import { AppShell } from "@/components/layout/AppShell";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <AppShell>
      <div className="grid min-h-[50vh] place-items-center text-center" data-testid="not-found-page">
        <div>
          <p className="font-brand text-6xl font-semibold text-brand-navy">404</p>
          <p className="mt-3 text-muted-foreground">This page doesn't exist in the foundation.</p>
          <Button asChild className="mt-6">
            <Link to="/">Back to overview</Link>
          </Button>
        </div>
      </div>
    </AppShell>
  );
}
